import { FormControl, FormHelperText } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { FullWidthTextFieldWrapper } from "@ryde/controls";
import { ADDRESS_SEARCH_DEFAULT_BOUNDS, ICustomField } from "@ryde/shared";

import { BoundsBlock } from "../../map";
import { toAddressSearchBounds } from "../../map/bounds-block.utils";

/**
 * The `addressSearchBounds` system param: a rectangle on a map rather than four raw numbers.
 *
 * Reset restores the field's seeded `newItemValue` where the form carries one — a company can
 * be given its own default that way — and the shipped rectangle otherwise, so the button
 * always has something to restore.
 */
export const MapBoundsTemplate: FC<ICustomField> = ({
  name,
  formAttributes,
}) => {
  const { control } = useFormContext();
  const defaultBounds =
    toAddressSearchBounds(formAttributes?.newItemValue) ??
    ADDRESS_SEARCH_DEFAULT_BOUNDS;

  return (
    <FullWidthTextFieldWrapper>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <FormControl error={!!error} data-e2e-template="map-bounds-template">
            <BoundsBlock
              // A cleared parameter arrives as null; the block works in "loaded or not".
              value={toAddressSearchBounds(value)}
              defaultBounds={defaultBounds}
              onChange={onChange}
            />
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        )}
      />
    </FullWidthTextFieldWrapper>
  );
};
